var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{style:(_vm.btnVisible ? 'display: block' : 'display: none'),attrs:{"type":"button","id":"scrollBtn","title":"Go to top"},on:{"click":_vm.topFunction}},[_c('font-awesome-icon',{attrs:{"icon":"fa-solid fa-arrow-up"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }